export default __webpack_public_path__ + "static/media/AKM æ¹æ¡.88f5e227.jpg";